export const FETCH_EDI_RAW_REQUEST = 'FETCH_EDI_RAW_REQUEST';
export const FETCH_EDI_RAW_SUCCESS = 'FETCH_EDI_RAW_SUCCESS';
export const FETCH_EDI_RAW_FAILURE = 'FETCH_EDI_RAW_FAILURE';
export const FETCH_EDI_FORMATTED_REQUEST = 'FETCH_EDI_FORMATTED_REQUEST';
export const FETCH_EDI_FORMATTED_SUCCESS = 'FETCH_EDI_FORMATTED_SUCCESS';
export const FETCH_EDI_FORMATTED_FAILURE = 'FETCH_EDI_FORMATTED_FAILURE';
